module.exports = __webpack_public_path__ + "static/media/monis-removebg-preview.521c7374.png";